export default "__VITE_ASSET__bkSMKrah__"